<template>
    <div class="header-wrap" ref="bar" :style="style">
        <div class="gradient_inner" ref="inner">
            <div v-if="env.isApp || showBack" class="gradient_inner_back" @click="back">
                <a href="javascript:;">
                    <img src="./images/ic_back.png" alt="返回" />
                </a>
            </div>
            <div v-if="title" class="gradient_title">{{ title }}</div>
            <slot v-else name="title"></slot>
            <ul v-if="env.isApp && events && events.length > 0" class="gradient_events">
                <li @click="item.event" v-for="(item, index) in events" :key="index">{{ item.name }}</li>
            </ul>
            <slot v-else name="right"></slot>
        </div>
    </div>
</template>
<script>
import { backToPreviousPage } from 'root/common/nativeApi/index.js';
import getMenuHeight from 'root/common/util/getMenuHeight';
import env from 'root/common/util/env';

export default {
    name: 'immersionHead',
    props: {
        events: Array,
        title: {
            default: '',
            type: String,
        },
        backgroundImage: {
            default: '',
            type: String,
        },
        zIndex: {
            default: 0,
            type: Number,
        },
        userStyle: {
            default: () => {},
            type: Object,
        },
        // 自定义返回方法
        onBack: {
            type: Function,
        },
        showBack: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        style() {
            const defaultStyle = {
                zIndex: `${this.zIndex}`,
            };
            const formatStyle = {
                ...this.userStyle,
            };
            if (this.backgroundImage) {
                formatStyle.backgroundImage = `url(
                    ${this.backgroundImage}
                )`;
                formatStyle.backgroundRepeat = 'no-repeat';
                formatStyle.backgroundSize = '100% 100%';
            }
            return { ...defaultStyle, ...formatStyle };
        },
    },
    data() {
        return {
            env,
            container: null,
        };
    },
    mounted() {
        if (env.isApp && env.isAndroid) this.setAndroidFn();
    },
    methods: {
        back() {
            this.$emit('back');
            if (this.onBack) {
                this.onBack();
                return;
            }
            if (window.__is_blackApp) {
                backToPreviousPage();
            } else {
                console.log('返回');
                history.go(-1);
            }
        },
        setAndroidFn() {
            const barDiv = this.$refs.bar;
            barDiv.style.paddingTop = getMenuHeight();
        },
    },
};
</script>
<style lang="scss" scoped>
.header-wrap {
    width: 100%;
    max-width: 750px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    position: relative;
    height: 0.88rem;
    background-color: transparent;
    .gradient_inner {
        width: 100%;
        min-height: 0.88rem;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        top: 0;
        z-index: 500;
        .gradient_inner_back {
            position: absolute;
            left: 0;
            top: 0;
            height: 0.88rem;
            width: 1.44rem;
            line-height: 0.88rem;
            display: flex;
            align-items: center;
            justify-content: center;
            a {
                position: absolute;
                left: 0.3rem;
                top: 0.2rem;
                width: 0.48rem;
                height: 0.48rem;
                img {
                    display: block;
                    width: 0.48rem;
                    height: 0.48rem;
                }
            }
        }
        .gradient_title {
            text-align: center;
            font-size: 0.32rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #252220;
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: 0.88rem;
        }
        .gradient_events {
            display: flex;
            justify-content: flex-end;
            font-size: 0.28rem;
            color: #333;
            position: absolute;
            right: 0;
            top: 0;
            li {
                margin-left: 0.2rem;
                height: 0.88rem;
                line-height: 0.88rem;
                position: relative;
                padding-right: 0.32rem;
            }
        }
    }
}
</style>
